module.exports = __webpack_public_path__ + "img/donazione-sangue.604c51af.jpg";